import React, { useContext, useState } from "react";
import { ModalServiceContext, RicosContext } from "./../../../../ricos-context";
import { getIsModalOpen, useModalState } from "./../../../../ricos-modals/modal-service-provider";
import { LINK_MODAL_ID } from "./../../../../_shared/link-modal/constants";
import { LinkIcon, ToggleButton } from "./../../../../toolbars-ui";
const LinkButton = ({ toolbarItem, dataHook }) => {
  const { t } = useContext(RicosContext);
  const modalService = useContext(ModalServiceContext);
  const isModalOpen = useModalState(getIsModalOpen(LINK_MODAL_ID));
  const [referenceElement, setReferenceElement] = useState();
  const onClick = () => {
    toolbarItem.commands.click({ referenceElement, modalService });
  };
  return /* @__PURE__ */ React.createElement(
    ToggleButton,
    {
      active: isModalOpen || toolbarItem.attributes.active,
      Icon: LinkIcon,
      tooltip: t(toolbarItem.presentation?.tooltip ?? "TextLinkButton_Tooltip"),
      onClick,
      setRef: setReferenceElement,
      dataHook
    }
  );
};
export {
  LinkButton
};
//# sourceMappingURL=LinkButton.js.map
